// One key per Hire Go action. While `hire-go-cue-actions` is on, each action
// needs its key on top of the rule it already had; see `canTakeGoAction`.
const GO_ACTION_PERMISSIONS = {
  HIRE_GO_ADVANCE_APPLICANTS: 'hire_go_advance_applicants',
  HIRE_GO_REJECT_APPLICANTS: 'hire_go_reject_applicants',
  HIRE_GO_MESSAGE_APPLICANTS: 'hire_go_message_applicants',
  HIRE_GO_EDIT_APPLICANT_ANSWERS: 'hire_go_edit_applicant_answers',
  HIRE_GO_MANAGE_SIGNATURE_REQUESTS: 'hire_go_manage_signature_requests',
  HIRE_GO_VIEW_SECURE_FILES: 'hire_go_view_secure_files',
  HIRE_GO_MANAGE_INTERVIEWS: 'hire_go_manage_interviews',
  HIRE_GO_MARK_ATTENDANCE: 'hire_go_mark_attendance',
  HIRE_GO_MANAGE_INTERVIEW_SETTINGS: 'hire_go_manage_interview_settings',
  HIRE_GO_CREATE_OPENINGS: 'hire_go_create_openings',
  HIRE_GO_MANAGE_OPENING_STATUS: 'hire_go_manage_opening_status',
  HIRE_GO_MANAGE_HIRING_TARGETS: 'hire_go_manage_hiring_targets',
} as const;

export type GoActionPermission =
  (typeof GO_ACTION_PERMISSIONS)[keyof typeof GO_ACTION_PERMISSIONS];

export const PERMISSIONS = {
  HIRE_GO: 'hire_go',
  HIRE_GO_MANAGE_USERS: 'hire_go_manage_users',
  HIRE_GO_MANAGE_ACTIVATION_FLOWS: 'hire_go_manage_activation_flows',
  HIRE_GO_MANAGE_APPLICANTS: 'hire_go_manage_applicants',
  HIRE_GO_VIEW_NOTES: 'hire_go_view_notes',
  HIRE_GO_MANAGE_NOTES: 'hire_go_manage_notes',
  HIRE_GO_MANAGE_OPENINGS: 'hire_go_manage_openings',
  HIRE_GO_MANAGE_CARD_DISPLAY: 'hire_go_manage_card_display',
  ...GO_ACTION_PERMISSIONS,
};
